'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.top50p = exports.left50p = exports.floatRight = exports.floatLeft = exports.float = exports.bgColor = exports.pos = exports.disp = exports.algnCnt = exports.remStyles = exports.rem = undefined;

var _zipObject2 = require('lodash/zipObject');

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _range2 = require('lodash/range');

var _range3 = _interopRequireDefault(_range2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _method2 = require('lodash/method');

var _method3 = _interopRequireDefault(_method2);

var _merge2 = require('lodash/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _keys2 = require('lodash/keys');

var _keys3 = _interopRequireDefault(_keys2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

exports.allSides = allSides;
exports.remStyleBuilder = remStyleBuilder;
exports.buildNumSizes = buildNumSizes;

var _capeLodash = require('cape-lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Takes a number or string and appends 'rem' to the end of it.
// Example: rem(1) === '1rem'
var rem = exports.rem = (0, _flow3.default)(String, (0, _method3.default)('concat', 'rem'));

function allSides() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref;

  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  return _ref = {}, _defineProperty(_ref, prefix + 'Top' + suffix, value), _defineProperty(_ref, prefix + 'Bottom' + suffix, value), _defineProperty(_ref, prefix + 'Left' + suffix, value), _defineProperty(_ref, prefix + 'Right' + suffix, value), _ref;
}

// Takes css defination style and a className prefix and builds out options with sizes from 0-6.
// Example: remStyleBuilder('margin', 'm') == { m0: { margin: 0 }, m0p5: { margin: '0.5rem' }, ...}
function remStyleBuilder(style, prefix) {
  var allSidesArgs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var sizes = {
    '0p125': 0.125,
    '0p25': 0.25,
    '0p5': 0.5,
    '0p75': 0.75,
    1: 1,
    '1p25': 1.25,
    '1p5': 1.5,
    '1p618': 1.618,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10
  };
  var sizeBuilder = (0, _capeLodash.createObj)(style);
  var zero = _defineProperty({}, prefix + '0', (0, _isArray3.default)(allSidesArgs) ? allSides.apply(undefined, _toConsumableArray(allSidesArgs)) : sizeBuilder(0));
  var remBuilder = (0, _flow3.default)(rem, (0, _isArray3.default)(allSidesArgs) ? _partial3.default.apply(undefined, [allSides].concat(_toConsumableArray(allSidesArgs))) : sizeBuilder);
  return (0, _merge3.default)(zero, (0, _zipObject3.default)((0, _map3.default)((0, _keys3.default)(sizes), function (key) {
    return prefix + key;
  }), (0, _map3.default)(sizes, remBuilder)));
}
// Define the things that should be sent to remStyleBuilder.
var remStyles = exports.remStyles = {
  br: 'borderRadius',
  fs: 'fontSize',
  h: 'height',
  lh: 'lineHeight',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft'
};

// Similar to remStyleBuilder but where the value is a number instead of rem string.
// buildNumSizes('zIndex', 'z') == { z0: { zIndex: 0 }, z1: { zIndex: 1 }, z2: { zIndex: 2 } ...}
function buildNumSizes(style, prefix) {
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 11;

  var sizes = (0, _range3.default)(start, end);
  var sizeBuilder = (0, _capeLodash.createObj)(style);
  return (0, _zipObject3.default)((0, _map3.default)(sizes, function (key) {
    return prefix + key;
  }), (0, _map3.default)(sizes, sizeBuilder));
}
// Builds an object with the position property set to the first argument.
// Example: pos('static') == { position: 'static' }
var algnCnt = exports.algnCnt = (0, _capeLodash.createObj)('alignContent');
var disp = exports.disp = (0, _capeLodash.createObj)('display');
var pos = exports.pos = (0, _capeLodash.createObj)('position');
var bgColor = exports.bgColor = (0, _capeLodash.createObj)('backgroundColor');
var float = exports.float = (0, _capeLodash.createObj)('float');

var floatLeft = exports.floatLeft = float('left');
var floatRight = exports.floatRight = float('right');
var left50p = exports.left50p = { left: '50%' };
var top50p = exports.top50p = { top: '50%' };


//////////////////
// WEBPACK FOOTER
// ./~/cape-style/lib/utils.js
// module id = 374
// module chunks = 0